// removed by extract-text-webpack-plugin
module.exports = {"Main":"Main__Main__1D27i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main.css
// module id = 106
// module chunks = 0